import vChatPrintTimestamp from "./v-chat-print-timestamp.vue";

export default Vue => {
  Vue.component("v-chat-print-timestamp", vChatPrintTimestamp);
};
